import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";

import { Home } from "../pages/home";
import { ContactUs } from "../pages/contact";
import { Investment } from "../pages/investment";
import { About } from "../pages/about";
import { Videography } from "../pages/videographypackage";
import { VideoandPhotography } from "../pages/videoandphotopage";
import { Photography } from "../pages/photographypackage";
import { PhotoGallary } from "../pages/photogallary";
import Login from "../pages/login";
import { Socialicons } from "../components/socialicons";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { Gallery } from "../pages/gallery";
// import TermsAndConditions from "../pages/terms/index";
import FAQ from "../pages/faq";
import PrivateRoute from "../privateRoute";

const AnimatedSwitch = withRouter(({ location }) => (
  <TransitionGroup>
    <CSSTransition
      key={location.key}
      // timeout={{
      //   enter: 300,
      //   exit: 300,
      // }}
      timeout={800}
      classNames="page"
      mountOnEnter
      unmountOnExit
    >
      <Switch location={location}>
        <Route exact path="/" component={Home} />
        <Route path="/about" component={About} />
        <Route path="/gallery" component={Gallery} />
        <Route path="/contact" component={ContactUs} />
        <Route path="/faqs" component={FAQ} />
        {/* <Route path="/investment" component={Investment} /> */}
        <PrivateRoute path="/investment" component={Investment} />
        <Route path="/photography-package" component={Photography} />
        <Route path="/photo-and-videopackage" component={VideoandPhotography} />
        <Route path="/videography-package" component={Videography} />
        <Route path="/photo-gallery" component={PhotoGallary} />
        <Route path="/login" component={Login} />
        {/* <Route path="/terms" component={TermsAndConditions} /> */}

        <Route path="*" component={Home} />
      </Switch>
    </CSSTransition>
  </TransitionGroup>
));

function AppRoutes() {
  return (
    <div className="s_c">
      <AnimatedSwitch />
      <Socialicons />
    </div>
  );
}

export default AppRoutes;
